import { StatsGraph } from "./stats_graph";
import $ from "jquery";

class GraphForm {
  enableCsvButton(element: JQuery<HTMLElement>): void {
    if (element.hasClass("enable_later")) {
      element.removeClass("disabled enable_later");
      const img = element.html();
      element.html("<a></a>");
      const a = element.children();
      a.append(img);
      a.attr("href", element.data("url"));
    }
  }

  enablePngDownloadButton(element: JQuery<HTMLElement>, graph: StatsGraph): void {
    element.removeClass("disabled");
    element.on("click", (e) => {
      e.preventDefault();
      graph.downloadAsPng();
    });

    // Add tooltip using title attribute (tipsy will pick it up automatically)
    element.attr("title", "画像をダウンロード");

    // Initialize tipsy if available
    if (typeof (element as any).tipsy === "function") {
      (element as any).tipsy({
        gravity: "s",
      });
    } else {
      // If tipsy is not loaded yet, try to load it and then initialize
      import("../vendor/jquery.tipsy").then(() => {
        if (typeof (element as any).tipsy === "function") {
          (element as any).tipsy({
            gravity: "s",
          });
        }
      });
    }
  }
}

export { GraphForm };
